import Layout from 'antd/lib/layout/layout'
import styled from 'styled-components'

export const StyledLayout = styled(Layout)`
    padding: 16px;
    height: 100vh;
    overflow-y: scroll;
`
